



























import Vue from "vue";
import { Component } from "vue-property-decorator";
import store from "../core/store";
import { Dictionary, gsClass, freeTextResult, classTerm } from "../core/types";
import TermsList from "./TermsList.vue";
import Term from "./Term.vue";



Vue.component("terms-list", TermsList);
Vue.component("term", Term);

@Component({
components: {},
})

export default class Results extends Vue {

    get hasGsData() {
        return (
        store.state.matchResult !== null &&
        store.state.matchResult.resultsBag.length > 0
        );
    }

    data(){
        var threshold_min : number = 0
        var threshold_max : number = 100
        if(store.state.matchResult !== null){
            threshold_min = store.state.matchResult.minConf
        }
        return{
            threshold : store.state.threshold,
            threshold_min :  threshold_min,
            threshold_max :  threshold_max,
        }
    }

    matchResult(threshold: number) {
        var threshold_float = threshold/100.0;
        console.log(threshold_float)
        if (store.state.matchResult) {
            const result = store.state.matchResult.resultsBag;
            let filtered_results: freeTextResult[];
            filtered_results = JSON.parse(JSON.stringify(result))
            var hasPicklist = false; // check if anything's in the picklists
            for (var i = 0; i < result.length; i++) {
                if (Object.keys(result[i].gsClassBag).length > 0) {
                    hasPicklist = true;
                    filtered_results[i].gsClassBag = filtered_results[i].gsClassBag.filter((gs_class: gsClass) => {
                        return gs_class.classMaxScore >= threshold_float});
                    for(var j in filtered_results[i].gsClassBag){
                        filtered_results[i].gsClassBag[j].classTermBag = filtered_results[i].gsClassBag[j].classTermBag.filter((class_term: classTerm) => {
                            return class_term.score >= threshold_float});
                    }

                }
            }
            return hasPicklist ? filtered_results : [];
        }
        return [];
    }

    get classList() {
        return (x: Dictionary<gsClass>) => {
            return Object.keys(x)
                .map((y) => ({
                class:  x[y].classNumber,
                classTermBag: x[y].classTermBag,
                score: x[y].classMaxScore,
                term: x[y].classDescription,
                termMarkedUp: x[y].classDescription,
                rank: x[y].classRank,
                }))
                .sort((a, b) => a.rank - b.rank);
        };
    }

    get displayedTextTypes() {
        return store.state.displayedTextType;
    }

    toDisplay(texttype: string) {
        return texttype === "freetext" || texttype === "picklist"
            ? this.displayedTextTypes[texttype]
            : false;
    }
}
